/**
 * Created by Jerker Nord on 2021-08-26.
 */
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {TrueGritGameAssets} from "../TrueGritGameAssets";
import {TrueGrit} from "../TrueGrit";
import {gsap, TimelineLite} from "gsap";
import {BasicBitmapCountUp} from "../components/BasicBitmapCountUp";
import {TrueGritParticleConfig} from "../configs/TrueGritParticleConfig";
import {TweenParticleEmitter} from "../components/TweenParticleEmitter";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";

export class TrueGritTotalBigWinView extends PIXI.Container implements StageLayer {
    private countUp:BasicBitmapCountUp;
    private _totalWaysWonText:PIXI.BitmapText;
    private _waysText:PIXI.Sprite;
    private _waysContainer:PIXI.Container;
    private _particleBackground:PIXI.Container;
    private _particleForeground:PIXI.Container;
    private _leftParticles:TweenParticleEmitter[];
    private _rightParticles:TweenParticleEmitter[];
    private _imageContainer:PIXI.Container;
    private _imageFrame:PIXI.Sprite;
    private _stillImage:PIXI.Sprite;
    private textContainer:PIXI.Container;
    private _background:PIXI.Sprite;

    constructor() {
        super();
        this.name = "TrueGritTotalBigWinView";
        this.init();
    }

    private init() {

        this._background = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._background.tint = 0x000000;
        this._background.alpha = 0.7;

        this.countUp = new BasicBitmapCountUp({
            fontName : TrueGritGameAssets.BITMAP_FONT_WIN_NUMBERS,
            fontSize : 190,
            tint : 0xffffff
        }, 720, new PIXI.Point(0.5, 0.5));
        this.countUp.position.set(0,0);
        this.countUp.scale.set(0.8,0.8);
        this.countUp.stopAt(0);

        this._waysContainer = new PIXI.Container();
        this._waysContainer.position.set(0, 10);

        this._totalWaysWonText = new PIXI.BitmapText("2", {
            fontName : TrueGritGameAssets.BITMAP_FONT_NUMBERS_WAYS_WON,
            fontSize : 59
        });
        this._totalWaysWonText.position.set(0, 0);
        this._waysText = new PIXI.Sprite(TrueGrit.assetLoader.getTextures(TrueGritGameAssets.WAYS_WON_TEXT)[0]);
        this._waysContainer.addChild(this._waysText, this._totalWaysWonText);

        this.textContainer = new PIXI.Container();
        this.textContainer.position.set(360,540);
        this.textContainer.addChild(this._waysContainer, this.countUp)

        this._imageContainer = new PIXI.Container();
        this._imageContainer.position.set(360,360);

        this._stillImage = new PIXI.Sprite(this.getLevelTexture(0))
        this._stillImage.anchor.set(0.5,0.5);
        this._imageContainer.addChild(this._stillImage);

        this._imageFrame = new PIXI.Sprite(TrueGrit.assetLoader.getTextures(TrueGritGameAssets.BW_FRAME)[0]);
        this._imageFrame.anchor.set(0.5, 0.5);
        this._imageContainer.addChild(this._imageFrame);

        this._particleBackground = new PIXI.Container();
        this._particleBackground.name = "_particleBackground";

        this._particleForeground = new PIXI.Container();
        this._particleForeground.name = "_particleForeground";

        this.createParticles(this._particleBackground, this._particleForeground);

        this.addChild(this._background);
        this.addChild(this._particleBackground);
        this.addChild(this._imageContainer);
        this.addChild(this.textContainer);
        this.addChild(this._particleForeground);


        this.hide();

        this.onResize();
    }


    onResize():void {
        this._background.width = NolimitApplication.screenBounds.width;
        this._background.height = NolimitApplication.screenBounds.height;
        this._background.x = NolimitApplication.screenBounds.left;
        this._background.y = NolimitApplication.screenBounds.top;
    }


    public getCountUpScaleAnimation(duration:number, ease:string, to:number, from?:number ):gsap.core.Timeline {
        const tl = gsap.timeline();
        if (from != undefined){
            tl.add(()=>{this.countUp.scale.set(from,from)});
        }
        tl.add(gsap.to(this.countUp.scale, {duration:duration, x:to, y:to, ease:ease}))

        return tl;
    }

    public precalculateScale(endValue:number){
        this.countUp.stopAt(0);
        this.countUp.preCalculateScale(0,endValue);
    }

    public show(duration:number):gsap.core.Timeline {
        TrueGrit.keypadPlugin.setWin(0, true, TrueGrit.isWinBelowStake());
        TrueGrit.snowParticles.stopSnow();
        const tl = gsap.timeline();
        tl.add(()=>{
            this._stillImage.texture = this.getLevelTexture(0);
            this.alpha = 0;
            this.visible = true;
            this._waysContainer.alpha = 0;
            this.countUp.alpha = 0;
        });
        tl.add(gsap.to(this, {duration:duration, alpha:1, ease:"none"}));

        return tl;
    }

    public hide(duration:number = 0.0001):gsap.core.Timeline {
        TrueGrit.snowParticles.startSnow();
        const tl = gsap.timeline();
        tl.add(gsap.to(this, {duration:duration, alpha:0}))
        tl.add(()=>{this._waysContainer.alpha = 0});
        tl.add(()=>{this.visible = false});

        return tl;
    }

    public showNumberOfWays(ways:number, duration:number):gsap.core.Timeline {
        this._totalWaysWonText.text = `${ways}`;
        this._waysText.texture = ways > 1 ? TrueGrit.assetLoader.getTextures(TrueGritGameAssets.WAYS_WON_TEXT)[0] : TrueGrit.assetLoader.getTextures(TrueGritGameAssets.WAY_WON_TEXT)[0];
        this._waysText.position.set(this._totalWaysWonText.width,6);
        this._waysContainer.position.x = -this._waysContainer.width * 0.5;

        const tl = gsap.timeline();
        tl.add(gsap.to(this._waysContainer, {duration:duration, alpha:1}))
        return tl;
    }

    public getLevelAnimation(countFrom:number, countTo:number, duration:number, level:number):gsap.core.Timeline{
        const tl = gsap.timeline();
        tl.add(this.countUp.getCountAnimation(countFrom, countTo,duration));
        tl.add(this.getParticleAnimation(0.01,level), "<");
        tl.add(this.getImageAnimation(level, duration), "<");
        tl.add(gsap.to(this.countUp, {duration:0.2, alpha:1}),"<");

        const scale = gsap.timeline();
        scale.add(this.getCountUpScaleAnimation(0.1,"power2.in", 1.2));
        scale.add(this.getCountUpScaleAnimation(0.2,"power2.out", 1.0));
        scale.add(this.getCountUpScaleAnimation(tl.duration() - 0.3,"power2.in", 0.8));
        tl.add(scale, 0);
        return tl;
    }

    // #511
    public stopBigWinCountUpAt(amount: number): void {
        this.countUp.stopAt(amount);
    }

    public getImageScalingAnimation(duration:number):gsap.core.Timeline {
        const tl = gsap.timeline();
        tl.add(()=>{
            this._imageContainer.scale.set(0.95,0.95);
        })
        tl.add(gsap.to(this._imageContainer.scale, {duration:duration, x:1.0, y:1.0, ease:"none"}));
        return tl;
    }


    private getImageAnimation(level:number, duration:number):gsap.core.Timeline {
        const tl = gsap.timeline();

        tl.add(()=>{
            this._stillImage.texture = this.getLevelTexture(level);
        });

        return tl;
    }

    private createParticles(background:PIXI.Container, foreground:PIXI.Container) {
        const particleTextures = [
            TrueGrit.assetLoader.getTextures(TrueGritGameAssets.BW_PARTICLES_LEVEL_1[0])[0],
        ];

        this._leftParticles = [];
        this._rightParticles = [];
        const emitterCount:number = 3;
        for(let i:number = 0; i < emitterCount; i++) {
            TrueGritParticleConfig.leftBigWinParticleConfigs[i].pos.x = -720 * 0.5;
            TrueGritParticleConfig.leftBigWinParticleConfigs[i].pos.y =  720;

            TrueGritParticleConfig.leftBigWinParticleConfigs[i].speed!.start = 1400;
            TrueGritParticleConfig.leftBigWinParticleConfigs[i].speed!.end = 1400;
            TrueGritParticleConfig.leftBigWinParticleConfigs[i].speed!.minimumSpeedMultiplier = 0.5;

            TrueGritParticleConfig.leftBigWinParticleConfigs[i].scale!.start = 0.5 + (0.1 * i);
            TrueGritParticleConfig.leftBigWinParticleConfigs[i].scale!.end = 0.5 + (0.1 * i);
            TrueGritParticleConfig.leftBigWinParticleConfigs[i].scale!.minimumScaleMultiplier = 0.5;
            const left:TweenParticleEmitter = new TweenParticleEmitter(particleTextures, TrueGritParticleConfig.leftBigWinParticleConfigs[i]);


            TrueGritParticleConfig.rightBigWinParticleConfigs[i].pos.x = 720 * 1.5;
            TrueGritParticleConfig.rightBigWinParticleConfigs[i].pos.y = 720;

            TrueGritParticleConfig.rightBigWinParticleConfigs[i].speed!.start = 1400;
            TrueGritParticleConfig.rightBigWinParticleConfigs[i].speed!.end = 1400;
            TrueGritParticleConfig.rightBigWinParticleConfigs[i].speed!.minimumSpeedMultiplier = 0.5;

            TrueGritParticleConfig.rightBigWinParticleConfigs[i].scale!.start = 0.5 + (0.1 * i);
            TrueGritParticleConfig.rightBigWinParticleConfigs[i].scale!.end = 0.5 + (0.1 * i);
            TrueGritParticleConfig.rightBigWinParticleConfigs[i].scale!.minimumScaleMultiplier = 0.5;
            const right:TweenParticleEmitter = new TweenParticleEmitter(particleTextures, TrueGritParticleConfig.rightBigWinParticleConfigs[i]);

            this._leftParticles.push(left);
            this._rightParticles.push(right);

            if(i > emitterCount * 0.5) {
                foreground.addChild(left);
                foreground.addChild(right);
            } else {
                background.addChild(left);
                background.addChild(right);
            }
        }
    }

    private getParticleAnimation(delay:number, level:number):TimelineLite {
        const maxParticles = 20;

        let tl:TimelineLite = new TimelineLite();

        for(let i:number = 0; i < this._leftParticles.length; i++) {
            const depthMaxCount = maxParticles * (this._leftParticles.length - i);
            let leftParticle = this._leftParticles[i];
            let rightParticle = this._rightParticles[i];

            tl.add(() => this.setParticlesProperty(i, level, depthMaxCount), 0);
            tl.add(() => leftParticle.start("slow(0.3, 0.8, false)", 2),delay);
            tl.add(() => rightParticle.start("slow(0.3, 0.8, false)", 2),delay);
        }
        tl.add(gsap.to(this, {duration:0.001}));
        //tl.add(()=> countDuration - 0.7 + 0.3);

        return tl;
    }

    private setParticlesProperty(index:number, level:number, maxParticles:number) {
        let baseScale:number;
        let depthFactor:number;
        let startColor:string;
        let endColor:string;
        let endScaleFactor:number;

        //textures

        /*
        L1. 90% 1, 10% 2
        L2. 30%1, 40% 2, 30% 3
        L3. 40% 2, 40% 3, 20% 4
        L4. 60% 3, 40% 4
        L5. 50% 4. , 50% 5
         */
        let levelTextures:PIXI.Texture[] = this.getLevelParticleTextures(level);

        //Scale
        baseScale = 1;
        switch(index) {
            case 0:
                endColor = "#a0a0a0";
                startColor = "#a0a0a0";
                depthFactor = 0.5;
                endScaleFactor = 1;
                break;
            case 1:
                startColor = "#ffffff";
                endColor = "#ffffff";
                depthFactor = 0.8;
                endScaleFactor = 1;
                break;
            case 2:
                startColor = "#ffffff";
                endColor = "#ffffff";
                depthFactor = 1;
                endScaleFactor = 1;
                break;
            default:
                startColor = "#ffffff";
                endColor = "#ffffff";
                depthFactor = 1;
                endScaleFactor = 2.5;
        }

        const startScale = baseScale * depthFactor;
        const endScale = startScale * endScaleFactor;

        this._leftParticles[index].emitterConfig.color.start = startColor;
        this._leftParticles[index].emitterConfig.color.end = endColor;
        this._leftParticles[index].emitterConfig.scale.start = startScale;
        this._leftParticles[index].emitterConfig.scale.end = endScale;
        this._leftParticles[index].emitterConfig.maxParticles = maxParticles;
        this._leftParticles[index].textures = levelTextures;
        this._leftParticles[index].updateConfig();

        this._rightParticles[index].emitterConfig.color.start = startColor;
        this._rightParticles[index].emitterConfig.color.end = endColor;
        this._rightParticles[index].emitterConfig.scale.start = startScale;
        this._rightParticles[index].emitterConfig.scale.end = endScale;
        this._rightParticles[index].emitterConfig.maxParticles = maxParticles;
        this._rightParticles[index].textures = levelTextures;
        this._rightParticles[index].updateConfig();
    }

    private getLevelParticleTextures(level:number):PIXI.Texture[]{
        let textureNames:string[] = [];
        const result:PIXI.Texture[] = [];

        if (level == 1){
            textureNames = textureNames.concat(TrueGritGameAssets.BW_PARTICLES_LEVEL_1);
            textureNames = textureNames.concat(TrueGritGameAssets.BW_PARTICLES_LEVEL_2);
        }
        else if (level == 2){
            textureNames = textureNames.concat(TrueGritGameAssets.BW_PARTICLES_LEVEL_1);
            textureNames = textureNames.concat(TrueGritGameAssets.BW_PARTICLES_LEVEL_2);
        }

        else if (level == 3){
            textureNames = textureNames.concat(TrueGritGameAssets.BW_PARTICLES_LEVEL_1);
            textureNames = textureNames.concat(TrueGritGameAssets.BW_PARTICLES_LEVEL_2);
            textureNames = textureNames.concat(TrueGritGameAssets.BW_PARTICLES_LEVEL_3);
            textureNames = textureNames.concat(TrueGritGameAssets.BW_PARTICLES_LEVEL_5[1]);
        }

        else if (level == 4){
            textureNames = textureNames.concat(TrueGritGameAssets.BW_PARTICLES_LEVEL_1);
            textureNames = textureNames.concat(TrueGritGameAssets.BW_PARTICLES_LEVEL_3);
            textureNames = textureNames.concat(TrueGritGameAssets.BW_PARTICLES_LEVEL_4);
            textureNames = textureNames.concat(TrueGritGameAssets.BW_PARTICLES_LEVEL_5[0]);
            textureNames = textureNames.concat(TrueGritGameAssets.BW_PARTICLES_LEVEL_5[1]);
        }

        else if (level >= 5){
            textureNames = textureNames.concat(TrueGritGameAssets.BW_PARTICLES_LEVEL_1);
            textureNames = textureNames.concat(TrueGritGameAssets.BW_PARTICLES_LEVEL_4);
            textureNames = textureNames.concat(TrueGritGameAssets.BW_PARTICLES_LEVEL_5);
            textureNames = textureNames.concat(TrueGritGameAssets.BW_PARTICLES_LEVEL_5);
        }

        for (let textureName of textureNames){
            result.push(TrueGrit.assetLoader.getTextures(textureName)[0]);
        }

        return result;
    }

    private getLevelTexture(level:number):PIXI.Texture {

        if (level == 0){
            return PIXI.Texture.EMPTY;
        }

        const textureString=  TrueGritGameAssets.BW_LEVEL_PREFIX + level;

        return TrueGrit.assetLoader.getTextures(textureString)[0];
    }
}